import axiosApi, { api } from '../../helpers/api-helper';
import Promise from 'lodash/_Promise';

export const apiGetSessions = async ({ page = 1, pageSize = 10 }) => {
  // pageSize is currently ignored by the backend. It returns 20 sessions per page by default.
  // eslint-disable-next-line max-len
  return await axiosApi.get(`${api.GROUND_TRUTH_UPDATES_API_ROOT_URL}/play-sessions?ips=true&page=${page}&pageSize=${pageSize}`);
};

export const apiGetSessionDetails = async ({ sessionId }) => {
  return await axiosApi.get(`${api.GROUND_TRUTH_UPDATES_API_ROOT_URL}/play-session/details?sid=${sessionId}`);
};

export const apiUpdateGroundTruth = async ({
  sessionId,
  ballDeliverySerialNumber,
  ballBounceLocation,
  returnShotType
}) => {
  return await axiosApi.put(`${api.GROUND_TRUTH_UPDATES_API_ROOT_URL}/play-session/update-ground-truth`, {
    play_session_id: sessionId,
    ball_delivery_serial_number: ballDeliverySerialNumber,
    ball_bounce_location_ground_truth: ballBounceLocation,
    return_shot_type_ground_truth: returnShotType,
  });
};

export const apiUpdateGroundTruthVerifiedFlag = async ({
  sessionId,
}) => {
  // eslint-disable-next-line max-len
  const url = `${api.GROUND_TRUTH_UPDATES_API_ROOT_URL}/play-session/set-ground-truth-verified?sid=${sessionId}&flag=true`;
  return await axiosApi.put(url);
};

export const apiSetActionRecognitionTestDatasetFlag = async ({
  sessionId,
  ballDeliverySerialNumber,
  flag,
}) => {
  // eslint-disable-next-line max-len
  const url = `${api.GROUND_TRUTH_UPDATES_API_ROOT_URL}/play-session/set-action-recognition-test-dataset-flag?ps_id=${sessionId}&b_id=${ballDeliverySerialNumber}&flag=${flag}`;
  return await axiosApi.put(url);
};

export const apiSetBallBounceDetectionTestDatasetFlag = async ({
  sessionId,
  ballDeliverySerialNumber,
  flag,
}) => {
  // eslint-disable-next-line max-len
  const url = `${api.GROUND_TRUTH_UPDATES_API_ROOT_URL}/play-session/set-ball-bounce-detection-test-dataset-flag?ps_id=${sessionId}&b_id=${ballDeliverySerialNumber}&flag=${flag}`;
  return await axiosApi.put(url);
};

export const apiHandleDownloadCSV = ({ sessionId, format = 'csv' }) => {
  return new Promise((resolve, reject) => {
    if (!sessionId) return reject(new Error('Session ID is required'));

    axiosApi
      .get(`${api.GROUND_TRUTH_UPDATES_API_ROOT_URL}/play-session/download-csv-data?sid=${sessionId}&format=${format}`)
      .then(response => resolve(response.data))
      .catch(err => reject(new Error(err.message || 'Download failed')));
  });
};
